const getSeparattedLabelsByComma = (badges) => badges.map((badge) => badge.label.toLowerCase()).join(', ');
const parseBreadcrumbsToCategoryName = (breadcrumbsUrls) => breadcrumbsUrls.map((url) => url.enName).join('>');
const priceToDigits = (price) => price.replace(/[^0-9 .,]/g, '');
const getProductMessage = (showUrgencyMessage) => (showUrgencyMessage ? 'almost gone' : 'coverage');

export default class AnalyticsTriggers {
  static productDetail(productPageState) {
    if (typeof window === 'undefined') return;

    if (window.digitalData?.get('flag.pdp-pageload-event-from-mfe', false)) {
      const triggerPageLoadEvent = () => {
        window.removeEventListener('crs-application-initialized', triggerPageLoadEvent);

        window.digitalData.trigger('analytics.product_detail', {
          event_name: 'product_detail',
          page_description: 'product',
          brand: productPageState.collectionData.brand,
          product_rating: productPageState?.reviewData?.averageOverallRating || 'null',
          category_id: productPageState.categoryId,
          collection_id: productPageState.collectionId,
          key_item_color: productPageState.collectionData?.activeProduct?.kicId,
          long_sku: productPageState.collectionData?.activeProduct?.storeItemNumber,
          short_sku: productPageState.collectionData?.qualifiedSku,
          price_flag: productPageState.collectionData?.activeProduct?.priceFlag,
          product_id: productPageState.collectionData?.activeProduct?.productId,
          product_name: productPageState.collectionData.activeProduct.productName,
          swatch_color: productPageState.collectionData.activeProduct.defaultSwatchSequence,
          product_badge: getSeparattedLabelsByComma(productPageState.collectionData.activeProduct.badges),
          price_list_local: priceToDigits(productPageState.collectionData?.activeProduct?.prices.list.originalPrice),
          price_offer_local: priceToDigits(productPageState.collectionData?.activeProduct?.prices.list.discountPrice),
          category_name: parseBreadcrumbsToCategoryName(productPageState.collectionData?.breadcrumbsUrls),
          pdp_inventory: `${getProductMessage(productPageState.collectionData?.showUrgencyMessage)}:${productPageState.collectionData?.activeProduct?.analyticsSwatchAvailability}`,
        });
      };
      window.addEventListener('crs-application-initialized', triggerPageLoadEvent);
    }
  }

  static swatchClick(productPageState) {
    if (typeof window === 'undefined') return;
    window.digitalData.trigger('swatch_click', {
      event_name: 'swatch_click',
      brand: productPageState.collectionData.brand,
      product_rating: productPageState?.reviewData?.averageOverallRating || 'null',
      category_id: productPageState.categoryId,
      collection_id: productPageState.collectionId,
      key_item_color: productPageState.collectionData?.activeProduct?.kicId,
      long_sku: productPageState.collectionData?.activeProduct?.storeItemNumber,
      short_sku: productPageState.collectionData?.qualifiedSku,
      price_flag: productPageState.collectionData?.activeProduct?.priceFlag,
      product_id: productPageState.collectionData?.activeProduct?.productId,
      product_name: productPageState.collectionData.activeProduct.productName,
      swatch_color: productPageState.collectionData.activeProduct.defaultSwatchSequence,
      product_badge: getSeparattedLabelsByComma(productPageState.collectionData.activeProduct.badges),
      price_list_local: priceToDigits(productPageState.collectionData?.activeProduct?.prices.list.originalPrice),
      price_offer_local: priceToDigits(productPageState.collectionData?.activeProduct?.prices.list.discountPrice),
      category_name: parseBreadcrumbsToCategoryName(productPageState.collectionData?.breadcrumbsUrls),
      inventory: `${getProductMessage(productPageState.collectionData?.showUrgencyMessage)}:${productPageState.collectionData?.activeProduct?.analyticsSwatchAvailability}`,
    });
  }

  static addToBag(productPageState, data) {
    if (typeof window === 'undefined') return;

    window.digitalData.trigger('add_to_cart', {
      sticky_atb: window.digitalData.get('addToBag.stickyAtb', false),
      event_name: 'add_to_cart',
      quantity: data.selectedQuantity,
      brand: productPageState.collectionData?.brand,
      category_id: productPageState.categoryId,
      collection_id: productPageState.collectionId,
      key_item_color: productPageState.collectionData?.activeProduct?.kicId,
      long_sku: productPageState.collectionData?.activeProduct?.storeItemNumber,
      short_sku: productPageState.collectionData?.qualifiedSku,
      price_flag: productPageState.collectionData?.activeProduct?.priceFlag,
      price_list_usd: data.atbResponseData.listPriceUSD,
      price_offer_usd: data.atbResponseData.offerPriceUSD,
      product_id: productPageState.collectionData?.activeProduct?.productId,
      product_rating: productPageState.reviewData.averageOverallRating || 'null',
      price_list_local: priceToDigits(productPageState.collectionData?.activeProduct?.prices.list.originalPrice),
      price_offer_local: priceToDigits(productPageState.collectionData?.activeProduct?.prices.list.discountPrice),
      category_name: parseBreadcrumbsToCategoryName(productPageState.collectionData?.breadcrumbsUrls),
      inventory: getProductMessage(productPageState.collectionData?.showUrgencyMessage),
      short_descriptor: productPageState.collectionData?.activeProduct?.shortDescription,
      social_proofing: productPageState.collectionData?.hasSocialProofing ?? false,
    });
    window.digitalData.set('addToBag.stickyAtb', false);
  }

  static universalScrollAction(dataAction) {
    if (typeof window === 'undefined') return;
    window.digitalData.trigger('universal_scroll', {
      Tealium_event: 'scroll',
      data_text: 'user scrolled to',
      data_action: dataAction,
    });
  }

  static universalClick(dataAction, dataText, product) {
    if (typeof window === 'undefined') return;
    window.digitalData.trigger('universal_click', {
      event_name: 'click',
      data_action: dataAction,
      data_text: dataText,
      ...product,
    });
  }
}
